var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.accommodation_list),function(accommodation,index){return _c('div',{key:_vm._uid+'accommodation'+index},[(accommodation.servizi.length)?_c('tabbed-info',{attrs:{"id":`service:${index}`,"items":_vm.map_tabbed_info(accommodation.servizi)}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }